export const authTexts = {
  login: {
    title: 'Espace partenaire Flip&Go',
    subtitle: 'Connectez-vous avec votre adresse email.',
    emailLabel: 'Adresse email',
    emailPlaceholder: 'votre@email.fr',
    submit: 'Recevoir mon code',
    submitting: 'Envoi en cours…',
    invalidEmail: 'Veuillez saisir une adresse email valide.',
    serverError: "L'envoi du code a échoué. Réessayez dans un instant.",
  },
  otp: {
    title: 'Vérification de votre identité',
    description: (email: string) =>
      `Si un compte partenaire existe pour ${email}, un code à 6 chiffres vient de vous être envoyé.`,
    hint: "Si vous ne l'avez pas reçu, cliquez sur « Renvoyer le code ».",
    validateButton: 'Valider',
    verifying: 'Vérification…',
    resendCode: 'Renvoyer le code',
    resendSuccess: 'Un nouveau code vient de vous être envoyé.',
    invalidCode: 'Code invalide ou expiré.',
    serverError: 'La vérification a échoué. Réessayez dans un instant.',
    changeEmail: "Modifier l'adresse email",
  },
  logout: {
    error: 'La déconnexion a échoué.',
  },
}
